<template>
  <v-container class="cmp-custom-text-settings dt-sidewindow submodule-root">
    <div class="dt-tabs-container submodule-root">
      <glayout :tabs="customTextSettingsTabs" tabPanelColor="secondary">
        <gtab id="booking" :showTabTitle="false">
          <grow>
            <gcol>
              <gbox :title="$t('offer_mail_to_artist')">
                <TemplateGroup2
                  :custom_textsSettingsData="custom_textsSettingsData"
                  :template_key="'offer_mail_to_artist'"
                  @updated="onTemplateUpdate"
                  @add_new="onTemplateAdd"
                  @deleted="onTemplateDele"
                />
              </gbox>
            </gcol>
            <gcol>
              <CustomTextHint 
                :datapoints="datapoints_dict.offer_mail_to_artist" 
                videoSrc="static/videos/settings_custom_texts_offer_mail_to_artist.mp4"
              />
            </gcol>
          </grow>

          <grow>
            <gcol>
              <gbox :title="$t('booking_request')">
                <TemplateGroup2
                  :custom_textsSettingsData="custom_textsSettingsData"
                  :template_key="'request_form_mail'"
                  @updated="onTemplateUpdate"
                  @add_new="onTemplateAdd"
                  @deleted="onTemplateDele"
                />
              </gbox>
            </gcol>
            <gcol>
              <CustomTextHint 
                :datapoints="datapoints_dict.request_form_mail" 
                videoSrc="static/videos/settings_custom_texts_request_form_mail.mp4"
              />
            </gcol>
          </grow>

          <grow>
            <gcol>              
              <gbox :title="$t('questionnaire_l')">
                <TemplateGroup2
                  :custom_textsSettingsData="custom_textsSettingsData"
                  :template_key="'promoter_questionnaire_mail'"
                  @updated="onTemplateUpdate"
                  @add_new="onTemplateAdd"
                  @deleted="onTemplateDele"
                />
              </gbox>
            </gcol>
            <gcol>
              <CustomTextHint 
                :datapoints="datapoints_dict.promoter_questionnaire_mail" 
                videoSrc="static/videos/settings_custom_texts_promoter_questionnaire_mail.mp4"
              />
            </gcol>
          </grow>

          <grow>
            <gcol>              
              <gbox :title="$t('send_document_and_files')">
                <TemplateGroup2
                  :custom_textsSettingsData="custom_textsSettingsData"
                  :template_key="'booking_document_and_files'"
                  @updated="onTemplateUpdate"
                  @add_new="onTemplateAdd"
                  @deleted="onTemplateDele"
                />
              </gbox>
            </gcol>
            <gcol>
              <CustomTextHint 
                :datapoints="datapoints_dict.booking_document_and_files" 
                videoSrc="static/videos/settings_custom_texts_booking_document_and_files.mp4"
              />
            </gcol>
          </grow>

              <!-- <grow>
              <gcol>
              <gbox :title="$t('booking_request')">
                <TemplateGroup
                  :custom_textsSettingsData="custom_textsSettingsData"
                  :template_key="'request_form_mail'"
                  @updated="onTemplateUpdate"
                  @add_new="onTemplateAdd"
                  @deleted="onTemplateDele"
                />
              </gbox>
              <gbox :title="$t('questionnaire_l')">
                <TemplateGroup
                  :custom_textsSettingsData="custom_textsSettingsData"
                  :template_key="'promoter_questionnaire_mail'"
                  @updated="onTemplateUpdate"
                  @add_new="onTemplateAdd"
                  @deleted="onTemplateDele"
                />
              </gbox>
              <gbox :title="$t('send_document_and_files')">
                <TemplateGroup
                  :custom_textsSettingsData="custom_textsSettingsData"
                  :template_key="'booking_document_and_files'"
                  @updated="onTemplateUpdate"
                  @add_new="onTemplateAdd"
                  @deleted="onTemplateDele"
                />
              </gbox>
            </gcol>
          </grow> -->
        </gtab>
        <!-- <gtab id="royalties">
          <grow>
            <gcol>
              <gbox :title="$t('details_b2b_statement_email')">
                <TemplateGroup
                  :custom_textsSettingsData="custom_textsSettingsData"
                  :template_key="'royalty_statement_email'"
                  @updated="onTemplateUpdate"
                  @add_new="onTemplateAdd"
                  @deleted="onTemplateDele"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab> -->
        <!-- <gtab id="distribution">
          <grow>
            <gcol>
              <gbox :title="$t('spo_reception_custom_email')">
                <TemplateGroup
                  :custom_textsSettingsData="custom_textsSettingsData"
                  :template_key="'po_reception_email'"
                  @updated="onTemplateUpdate"
                  @add_new="onTemplateAdd"
                  @deleted="onTemplateDele"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab> -->
        <gtab id="send_document_and_files">
          <grow>
            <gcol> </gcol>
          </grow>
        </gtab>
        <!-- <gtab id="assistant_intelligence">
          <grow>
            <gcol>
              <gbox :title="$t('assistant_intelligence')">
                <AI_Templates
                  :custom_textsSettingsData="custom_textsSettingsData"
                  @updated="onTemplateUpdate"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab> -->
      </glayout>
    </div>
  </v-container>
</template>
<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import * as ActionTypes from "../../store/types";
import { SettingsStoreNamespace as storeNS } from "../../store";

import { customTextGrid } from "./list-grid";

import {
  createGridHost,
  createSidewindowTabulation,
} from "../../../../dt-plugins/sidewindow";
import { mapKeyToAction, mapActionObject } from "../../../../store/global";
import { mapGetters } from "vuex";
import {
  createModalMixin,
  openModalRoute,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import { custom_textsSettingsActions } from "../../store/custom_texts/actions";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

import TemplateGroup from "./template-group";
import TemplateGroup2 from "./template-group2";
import AI_Templates from "./ai-templates";
import CustomTextHint from "./custom-text-hint";

export default {
  components: {
    ModalContainer,

    TemplateGroup,
    TemplateGroup2,
    AI_Templates,
    CustomTextHint,
  },
  mounted: function () {
    this[ActionTypes.Custom_textsSettingsData.FETCH.ALL]();
  },
  data: function () {
    return {
      gridLayout: customTextGrid,
      datapoints_dict: {
        offer_mail_to_artist: `[% start_date %], [% booking_location_name %], [% city %], [% country %], [% first_offer_notes %], [% artist %], [% artist_stage %] [% performance_type %], [% event_name %], [% notes_ical %], [% line_up %], [% venue_name %], [% venue_address %], [% venue_city %], [% venue_postalcode %], [% venue_country %], [% venue_phone %], [% venue_email %], [% venue_url %], [% venue_capacity %], [% promoter_company_name %], [% promoter_representative %], [% promoter_address %], [% promoter_city %], [% promoter_postalcode %], [% promoter_state %], [% promoter_country %], [% promoter_phone %], [% promoter_mobile %], [% promoter_email %], [% promoter_vat_id %], [% promoter_url %], [% promoter_language %]`,
        request_form_mail: `[% request_link %]`,
        promoter_questionnaire_mail: `[% start_date %], [% booking_location_name %], [% city %], [% country %], [% venue_url %], [% venue_capacity %], [% artists %], [% questionnaire_link %]`,
        booking_document_and_files:`[% start_date %], [% booking_location_name %], [% city %], [% country %], [% venue_url %], [% venue_capacity %], [% artists %], [% documents %], [% invoices %], [% files %]`
      }
    };
  },
  mixins: [
    createDTGridHost(),

    // createGridHost({
    //   layoutName: "gridLayout",
    //   gridRef: "gridLayout",
    // }),
    // createSidewindowTabulation({
    //   sideWindowTabsKey: "customTextSettingsTabs",
    //   defaultTab: "booking",
    // }),
    createModalMixin("addCurrency"),
    createModalMixin("addTerritory"),
    createModalMixin("editTerritory"),
  ],
  computed: {
    ...mapGetters(storeNS, {
      custom_textsSettingsData: "custom_textsSettingsData",
    }),
    customTextSettingsTabs: function () {
      return [
        {
          route: "booking",
          value: this.$t("booking"),
        },
        // {
        //   route: "royalties",
        //   value: this.$t("royalties"),
        // },
        // {
        //   route: "distribution",
        //   value: this.$t("distribution"),
        // },
        // {
        //   route: "assistant_intelligence",
        //   value: this.$t("assistant_intelligence"),
        // },
      ];
    },
    offer_mail_to_artist_templates: function () {
      return (
        this.custom_textsSettingsData?.offer_mail_to_artist?.templates || []
      );
    },
  },
  methods: {
    ...mapActionObject(storeNS, custom_textsSettingsActions),
    tabSelectedRouting: function (tabId) {
      this.$router.push({
        name: "settings_custom_texts_tab",
        params: {
          tab: tabId,
        },
      });
    },
    onTemplateUpdate: function (payload) {
      this[ActionTypes.Templates.UPDATE.SINGLE](payload);
    },
    onTemplateAdd: function (payload) {
      this[ActionTypes.Templates.INSERT.SINGLE](payload);
    },
    onTemplateDele: async function (payload) {
      const confirmationResult = await confirmDelete(
        "Tempalte",
        payload.description
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.Templates.DELETE.SINGLE](payload);
      }
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-custom-text-settings {
  background: var(--bc-3, #f6f6f6);
  padding: 8px 32px;

  .dt-grid-layout {
    height: calc(100vh - 108px);
  }
}
</style>